// Tiny IndexedDB queue for photos captured while offline.
const DB = 'ab-offline';
const STORE = 'pending_uploads';

const open = () => new Promise((res, rej) => {
  const r = indexedDB.open(DB, 1);
  r.onupgradeneeded = () => r.result.createObjectStore(STORE, { keyPath: 'id' });
  r.onsuccess = () => res(r.result);
  r.onerror = () => rej(r.error);
});

const tx = async (mode, fn) => {
  const db = await open();
  return new Promise((res, rej) => {
    const t = db.transaction(STORE, mode);
    const req = fn(t.objectStore(STORE));
    t.oncomplete = () => res(req?.result);
    t.onerror = () => rej(t.error);
  });
};

export const queueUpload = (item) => tx('readwrite', (s) => s.put({ id: `pend_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`, created_at: new Date().toISOString(), ...item }));
export const listPending = () => tx('readonly', (s) => s.getAll());
export const removePending = (id) => tx('readwrite', (s) => s.delete(id));
